/**
 * @description : The Tealium Service.
 * @requires {Object} $window: The Angular $window Service.
 **/
function tealiumService($window) {

  // Tags which will persist throughout the application.
  let baseTags = {};

  return {

    setBaseTags: (tags) => {

      baseTags = tags;

    },

    getBaseTags: () => baseTags,
    /**
     * @description Send expected Tealium tags.
     * @param {Object} tags An object of Tealium tags to send.
     * @param {String} type The type of tracking to be used.
     * @return {Boolean} True if the Tealium tags have been set false instead.
     */
    sendTags: (tags, type) => {

      if (!angular.isDefined($window.utag) || !angular.isDefined($window.utag.view)) {

        return false;

      }

      if (type === 'link') { 

        return $window.utag.link(tags);

      }

      return $window.utag.view(angular.merge(baseTags, tags));

    }

  };

}

export default tealiumService;


// WEBPACK FOOTER //
// ./src/angular-services/tealium.service.js